// src/LabResults.js

import React from 'react';

export default function LabResults({
  labResults,
  addLab,
  updLab,
  delLab,
  moldChange
}) {
  // List of mold genera for selection
  const moldOptionsList = [
    'Aspergillus',
    'Penicillium',
    'Cladosporium',
    'Alternaria',
    'Stachybotrys',
    'Chaetomium',
    'Acremonium',
    'Ulocladium',
    'Trichoderma',
    'Fusarium',
  ];

  return (
    <div className="mb-6">
      {/* Button to add a new lab result */}
      <button
        onClick={addLab}
        className="px-3 py-1 bg-gray-200 text-gray-800 rounded mb-4"
      >
        Add Laboratory Result
      </button>

      {labResults.map((lab, i) => (
        <div key={i} className="border border-gray-300 p-4 mb-4 rounded-lg">
          {/* Header with delete */}
          <div className="flex items-center justify-between mb-3">
            <h4 className="font-semibold">Lab Result {i + 1}</h4>
            <button
              onClick={() => delLab(i)}
              className="bg-red-200 text-red-800 px-2 py-1 rounded"
            >
              Delete
            </button>
          </div>

          {/* Lab Area, Sample Serial, Sample Method */}
          <div className="flex flex-col md:flex-row md:gap-4 mb-4">
            {/* Lab Area control */}
            <div className="flex-1">
              <label className="block mb-1 font-medium">
                Lab Area – Liters Air Sample Type or Specific Type
              </label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded px-2 py-1"
                placeholder="Lab Area"
                value={lab.roomArea}
                onChange={e => updLab(i, 'roomArea', e.target.value)}
              />
            </div>
            {/* Sample Serial */}
            <div className="flex-1">
              <label className="block mb-1 font-medium">Sample Serial</label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded px-2 py-1"
                placeholder="##########"
                value={lab.sampleSerial}
                onChange={e => updLab(i, 'sampleSerial', e.target.value)}
              />
            </div>
            {/* Sample Method */}
            <div className="flex-1">
              <label className="block mb-1 font-medium">Sample Method</label>
              <select
                className="w-full border border-gray-300 rounded px-2 py-1"
                value={lab.sampleMethod}
                onChange={e => updLab(i, 'sampleMethod', e.target.value)}
              >
                <option value="">Method</option>
                <option>Air Spore Trap</option>
                <option>Bulk Material Sample</option>
                <option>Swab</option>
                <option>Tape Lift</option>
                <option>qPCR</option>
              </select>
            </div>
          </div>

          {/* Air Spore Trap specifics */}
          {lab.sampleMethod === 'Air Spore Trap' && (
            <div className="space-y-4 mb-4">
              <div>
                <label className="block mb-1 font-medium">Air Sample Type</label>
                <select
                  className="w-full border border-gray-300 rounded px-2 py-1"
                  value={lab.airSampleType}
                  onChange={e => updLab(i, 'airSampleType', e.target.value)}
                >
                  <option value="">Select Air Sample Type</option>
                  <option>Ambient General Air</option>
                  <option>Disturbed General Air</option>
                  <option>Mechanical Agitated Wall Cavity</option>
                  <option>Mechanical Agitated Structural Cavity</option>
                  <option>Direct Surface</option>
                </select>
              </div>
              <div className="flex flex-col md:flex-row md:gap-4">
                <div className="flex-1">
                  <label className="block mb-1 text-sm">Minutes</label>
                  <input
                    type="number"
                    min="0"
                    className="w-full border border-gray-300 rounded px-2 py-1"
                    value={lab.minutes || ''}
                    onChange={e => updLab(i, 'minutes', e.target.value)}
                  />
                </div>
                <div className="flex-1">
                  <label className="block mb-1 text-sm">Liters</label>
                  <input
                    type="text"
                    readOnly
                    className="w-full border border-gray-300 rounded px-2 py-1 bg-gray-50"
                    value={lab.minutes ? lab.minutes * 15 : ''}
                  />
                </div>
              </div>
            </div>
          )}

          {/* Extent */}
          <div className="mb-4">
            <label className="block mb-1 font-medium">Extent</label>
            <select
              className="w-full border border-gray-300 rounded px-2 py-1"
              value={lab.extensiveSubstantial}
              onChange={e => updLab(i, 'extensiveSubstantial', e.target.value)}
            >
              <option value="">Select Extent</option>
              <option>Extensive</option>
              <option>Substantial</option>
              <option>Moderate</option>
              <option>Light</option>
              <option>Trace</option>
              <option>No Significant</option>
            </select>
          </div>

          {/* Mold Genus */}
          <div className="mb-4">
            <label className="block mb-1 font-medium">Mold Genus:</label>
            <select
              multiple
              className="w-full border border-gray-300 rounded px-2 py-1"
              value={lab.moldName}
              onChange={e => {
                // Build option objects to match moldChange signature
                const opts = Array.from(e.target.selectedOptions).map(opt => ({
                  value: opt.value,
                  label: opt.value,
                }));
                moldChange(i, opts);
              }}
            >
              {moldOptionsList.map(genus => (
                <option key={genus} value={genus}>
                  {genus}
                </option>
              ))}
            </select>
          </div>

          {/* Button to add another lab result */}
          <button
            onClick={addLab}
            className="px-3 py-1 bg-gray-200 text-gray-800 rounded"
          >
            Add Laboratory Result
          </button>
        </div>
      ))}
    </div>
  );
}
